export default __webpack_public_path__ + "static/media/csv.81a95090.svg";